// eslint-disable-next-line no-unused-vars
import * as Turbo from '@hotwired/turbo';
import { setupImageLightBox } from './image';
import { setupVideo } from './video';
import { setupMenu } from './menu';

window.addEventListener('DOMContentLoaded', () => {
  main();
});

document.addEventListener('turbo:render', () => {
  main();
});

function main() {
  setupImageLightBox();
  setupVideo();
  setupMenu();
}
